export const PRICE_FINDER_CONTAINER = 'priceBlock';
